<div class="modal-header">
  <h5 class="modal-title">Alterar dados</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()"
  ></button>
</div>
<div class="modal-body">
  <div class="bloco-subtitulo">
    <p class="subtitulo">Confirme as alterações digitando sua senha</p>
  </div>
  <form class="bloco-form">
    <div class="row">
      <div class="col-md-6">
        <label for="senhaConfirmacao" class="form-label">Sua senha</label>
        <input
          type="password"
          class="form-control"
          placeholder="******"
          id="strSenha"
          name="strSenha"
          value="<%=strSenha%>"
        />
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn btn-link">Esqueci a senha</button>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <div class="btn-acoes">
    <button
      type="button"
      class="btn btn-link btn-voltar"
      (click)="closeModal()"
    >
      voltar
    </button>
    <button type="button" class="btn btn-primary" (click)="confirmarSenha()">
      confirmar senha
    </button>
  </div>
</div>
